export const BulkInviteRoles = ['Participant', 'Volunteer', 'Teacher', 'Judge', 'Staff'] as const;
export const MaxBulkInviteRows = 200;
export type BulkInviteRole = typeof BulkInviteRoles[number];

export type BulkInviteMappingTarget = 'ignore' | 'fullName' | 'firstName' | 'lastName' | 'email' | 'phone' | 'role';

export interface IBulkInviteMappingOption {
  key: BulkInviteMappingTarget;
  label: string;
}

export const BulkInviteMappingOptions: IBulkInviteMappingOption[] = [
  { key: 'ignore', label: 'Ignore this column' },
  { key: 'fullName', label: 'Full Name' },
  { key: 'firstName', label: 'First Name' },
  { key: 'lastName', label: 'Last Name' },
  { key: 'email', label: 'Email' },
  { key: 'phone', label: 'Phone Number' },
  { key: 'role', label: 'Role' },
];

const HeaderAliases: Record<BulkInviteMappingTarget, string[]> = {
  ignore: [],
  fullName: ['full name', 'fullname', 'name'],
  firstName: ['first name', 'firstname', 'first'],
  lastName: ['last name', 'lastname', 'last'],
  email: ['email', 'email address', 'e-mail', 'emailaddress'],
  phone: ['phone', 'phone number', 'phonenumber', 'mobile', 'cell', 'cell phone'],
  role: ['role', 'user role', 'security role', 'type'],
};

export function AutoMapHeader(header: string): BulkInviteMappingTarget {
  const normalized = (header || '').trim().toLowerCase();
  if (!normalized) return 'ignore';

  for (const target of Object.keys(HeaderAliases) as BulkInviteMappingTarget[]) {
    if (HeaderAliases[target].includes(normalized)) return target;
  }
  return 'ignore';
}

export interface IBulkInviteRow {
  Key: string;
  FirstName: string;
  LastName: string;
  Email: string;
  Phone: string;
  Role: string;
}

export function IsValidEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((email || '').trim());
}

export function IsRowBlank(row: IBulkInviteRow): boolean {
  return !row.FirstName?.trim() && !row.LastName?.trim() && !row.Email?.trim() && !row.Phone?.trim();
}

export function IsRowValid(row: IBulkInviteRow): boolean {
  return IsValidEmail(row.Email) && BulkInviteRoles.includes(row.Role as BulkInviteRole);
}

export interface IBulkInviteRowResult {
  RowIndex: number;
  Email: string;
  Success: boolean;
  Message: string;
}

export interface IBulkInviteResult {
  InvitedCount: number;
  Rows: IBulkInviteRowResult[];
}
